import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import Theme from "./theme/Theme";
import store from "./store";
import BusyLoader from "./components/BusyLoader";
import { KeycloakProvider } from "./KeycloakProvider";
import App from "App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";   // ✅ Add this


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={<BusyLoader open={true} />}>
      <Provider store={store}>

        {/* <I18nextProvider i18n={i18nInstance}> */}
        <ThemeProvider theme={Theme}>
          <KeycloakProvider>
            <App />
          </KeycloakProvider>
          {/* <IdleTimerContainer /> */}
          {/* <IdleLogoutDialog /> */}
        </ThemeProvider>
        {/* </I18nextProvider> */}
      </Provider>
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

serviceWorkerRegistration.unregister();
reportWebVitals();
